import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';

const items = [
    {
        'category': '家電',
        'item': [{
                    'option': 'AirPods',
                    'src': '../img/AirPods.jpg',
                    'order': 1,
                    'label': 'AirPods Pro3 (現物)'
                }, {
                    'option': 'Sharp',
                    'src': '../img/Sharp.jpg',
                    'order': 2,
                    'label': 'SHARP 加湿空気清浄機 (目録)'
                }, {
                    'option': 'Echo',
                    'src': '../img/Echo.jpg',
                    'order': 3,
                    'label': '(スマートホームセット) Amazon Echo Dot + NatureRemo3 (現物)'
                }, {
                    'option': 'Bruno',
                    'src': '../img/Bruno.png',
                    'order': 4,
                    'label': 'BRUNO ホットプレート (目録)'
                }, {
                    'option': 'Terra',
                    'src': '../img/Terra.jpg',
                    'order': 5,
                    'label': 'ソーダストリーム TERRA (現物)'
                }]
        },
        {
            'category': '美容・健康',
                    'item': [{
                    'option': 'Lamdash',
                    'src': '../img/Lamdash.jpg',
                    'order': 6,
                    'label': 'Panasonic ラムダッシュパームイン (現物)'
                }, {
                    'option': 'Kassa',
                    'src': '../img/Kassa.jpg',
                    'order': 7,
                    'label': 'Panasonic リフトケア美顔器 バイタリフト かっさ (現物)'
                }, {
                    'option': 'Mytrex',
                    'src': '../img/Mytrex.jpg',
                    'order': 8,
                    'label': 'MYTREX ヒートネック (現物)'
                }, {
                    'option': 'Shiro',
                    'src': '../img/Shiro.jpg',
                    'order': 9,
                    'label': 'SHIRO ルームフレグランス (現物)'
                }, {
                    'option': 'Aesop',
                    'src': '../img/Aesop.jpg',
                    'order': 10,
                    'label': 'Aesop アロマティック ハンドウォッシュ (現物)'
                }]
        },
        {
            'category': '体験 (旅行・テーマパークなど)',
            'item': [{
                    'option': 'Experience',
                    'src': '../img/Experience.jpg',
                    'order': 11,
                    'label': '体験型Gift Premium ペア'
                }, {
                    'option': 'Disney',
                    'src': '../img/disney.jpg',
                    'order': 12,
                    'label': 'ディズニーチケット ペア'
                }, {
                    'option': 'Tea',
                    'src': '../img/Tea.jpg',
                    'order': 13,
                    'label': '高級ホテルアフタヌーンティ ペア'
                }, {
                    'option': 'Hiruton',
                    'src': '../img/Hiruton.jpg',
                    'order': 14,
                    'label': 'ヒルトン東京日本料理食事券 ペア'
                }, {
                    'option': 'Spa',
                    'src': '../img/Spa.jpg',
                    'order': 15,
                    'label': 'Times Spa Resta 利用券 ペア'
                }, {
                    'option': 'Sauna',
                    'src': '../img/Sauna.jpg',
                    'order': 16,
                    'label': 'サウナスパ利用券 1~2名'
                }, {
                    'option': 'Cafe',
                    'src': '../img/Cafe.jpg',
                    'order': 17,
                    'label': 'カフェ利用券'
                }]
        },
        {
            'category': 'グルメ',
                    'item': [{
                    'option': 'Matsuzaka',
                    'src': '../img/Matsuzaka.jpg',
                    'order': 16,
                    'label': '松坂牛 サーロインステーキ 200g×2 (目録)'
                }, {
                    'option': 'Crab',
                    'src': '../img/Crab.jpg',
                    'order': 17,
                    'label': '北海道産 ボイル毛ガニ 2尾 (目録)'
                }, {
                    'option': 'Conger',
                    'src': '../img/Conger.jpg',
                    'order': 18,
                    'label': '淡路島 焼きアナゴ 5本セット (目録)'
                }, {
                    'option': 'Sukiyaki',
                    'src': '../img/Sukiyaki.jpg',
                    'order': 19,
                    'label': '三田和牛 肩ロース すき焼き 300g (目録)'
                }, {
                    'option': 'Shabu',
                    'src': '../img/Shabu.jpg',
                    'order': 20,
                    'label': '平田牧場 三元豚しゃぶしゃぶ (目録)'
                }, {
                    'option': 'Kobe',
                    'src': '../img/Kobe.jpg',
                    'order': 21,
                    'label': '神戸牛 すき焼き用 モモ肉 250g (目録)'
                }, {
                    'option': 'Sensuke',
                    'src': '../img/Sensuke.jpg',
                    'order': 22,
                    'label': '日本酒 仙介 純米大吟醸 720ml (現物)'
                }, {
                    'option': 'Rice',
                    'src': '../img/Rice.jpg',
                    'order': 23,
                    'label': '長岡産 コシヒカリ 5kg (目録)'
                }, {
                    'option': 'Melon',
                    'src': '../img/Melon.jpg',
                    'order': 24,
                    'label': '静岡県産 クラウンマスクメロン (目録)'
                }, {
                    'option': 'Oyster',
                    'src': '../img/Oyster.jpg',
                    'order': 25,
                    'label': '広島県産 大粒カキフライ 20個 (目録)'
                }, {
                    'option': 'Ice',
                    'src': '../img/Ice.jpg',
                    'order': 26,
                    'label': '銀座千疋屋 ミルフィーユアイス (目録)'
                }, {
                    'option': 'Kaisen',
                    'src': '../img/Kaisen.jpg',
                    'order': 27,
                    'label': '能登半島 北陸海鮮漬け丼の具 6食 (目録)'
                }, {
                    'option': 'Steak',
                    'src': '../img/Steak.jpg',
                    'order': 28,
                    'label': '神戸洋食 デミグラスハンバーグ 9個 (目録)'
                }, {
                    'option': 'Chinese',
                    'src': '../img/Chinese.jpg',
                    'order': 29,
                    'label': '赤坂四川飯店監修 中華料理セット (目録)'
                }, {
                    'option': 'Financier',
                    'src': '../img/Financier.jpg',
                    'order': 30,
                    'label': 'シェフ・アサヤマ フィナンシェ 12個 (目録)'
                }, {
                    'option': 'Ramen',
                    'src': '../img/Ramen.jpg',
                    'order': 31,
                    'label': '喜多方ラーメン 12食 (目録)'
                }, {
                    'option': 'Cake',
                    'src': '../img/Cake.jpg',
                    'order': 32,
                    'label': 'ホシフルーツ 大人のチーズケーキ (目録)'
            }]
    }
]
    const options = [
        {
                    'option': 'AirPods',
                    'src': '../img/AirPods.jpg',
                    'order': 1,
                    'label': 'AirPods Pro3 (現物)'
                }, {
                    'option': 'Sharp',
                    'src': '../img/Sharp.jpg',
                    'order': 2,
                    'label': 'SHARP 加湿空気清浄機 (目録)'
                }, {
                    'option': 'Echo',
                    'src': '../img/Echo.jpg',
                    'order': 3,
                    'label': '(スマートホームセット) Amazon Echo Dot + NatureRemo3 (現物)'
                }, {
                    'option': 'Bruno',
                    'src': '../img/Bruno.png',
                    'order': 4,
                    'label': 'BRUNO ホットプレート (目録)'
                }, {
                    'option': 'Terra',
                    'src': '../img/Terra.jpg',
                    'order': 5,
                    'label': 'ソーダストリーム TERRA (現物)'
        },
        {
                    'option': 'Lamdash',
                    'src': '../img/Lamdash.jpg',
                    'order': 6,
                    'label': 'Panasonic ラムダッシュパームイン (現物)'
                }, {
                    'option': 'Kassa',
                    'src': '../img/Kassa.jpg',
                    'order': 7,
                    'label': 'Panasonic リフトケア美顔器 バイタリフト かっさ (現物)'
                }, {
                    'option': 'Mytrex',
                    'src': '../img/Mytrex.jpg',
                    'order': 8,
                    'label': 'MYTREX ヒートネック (現物)'
                }, {
                    'option': 'Shiro',
                    'src': '../img/Shiro.jpg',
                    'order': 9,
                    'label': 'SHIRO ルームフレグランス (現物)'
                }, {
                    'option': 'Aesop',
                    'src': '../img/Aesop.jpg',
                    'order': 10,
                    'label': 'Aesop アロマティック ハンドウォッシュ (現物)'
        },
        {
                    'option': 'Experience',
                    'src': '../img/Experience.jpg',
                    'order': 11,
                    'label': '体験型Gift Premium ペア'
                }, {
                    'option': 'Disney',
                    'src': '../img/disney.jpg',
                    'order': 12,
                    'label': 'ディズニーチケット ペア'
                }, {
                    'option': 'Tea',
                    'src': '../img/Tea.jpg',
                    'order': 13,
                    'label': '高級ホテルアフタヌーンティ ペア'
                }, {
                    'option': 'Hiruton',
                    'src': '../img/Hiruton.jpg',
                    'order': 14,
                    'label': 'ヒルトン東京日本料理食事券 ペア'
                }, {
                    'option': 'Spa',
                    'src': '../img/Spa.jpg',
                    'order': 15,
                    'label': 'Times Spa Resta 利用券 ペア'
                }, {
                    'option': 'Sauna',
                    'src': '../img/Sauna.jpg',
                    'order': 16,
                    'label': 'サウナスパ利用券 1~2名'
                }, {
                    'option': 'Cafe',
                    'src': '../img/Cafe.jpg',
                    'order': 17,
                    'label': 'カフェ利用券'
        },
        {
                    'option': 'Matsuzaka',
                    'src': '../img/Matsuzaka.jpg',
                    'order': 16,
                    'label': '松坂牛 サーロインステーキ 200g×2 (目録)'
                }, {
                    'option': 'Crab',
                    'src': '../img/Crab.jpg',
                    'order': 17,
                    'label': '北海道産 ボイル毛ガニ 2尾 (目録)'
                }, {
                    'option': 'Conger',
                    'src': '../img/Conger.jpg',
                    'order': 18,
                    'label': '淡路島 焼きアナゴ 5本セット (目録)'
                }, {
                    'option': 'Sukiyaki',
                    'src': '../img/Sukiyaki.jpg',
                    'order': 19,
                    'label': '三田和牛 肩ロース すき焼き 300g (目録)'
                }, {
                    'option': 'Shabu',
                    'src': '../img/Shabu.jpg',
                    'order': 20,
                    'label': '平田牧場 三元豚しゃぶしゃぶ (目録)'
                }, {
                    'option': 'Kobe',
                    'src': '../img/Kobe.jpg',
                    'order': 21,
                    'label': '神戸牛 すき焼き用 モモ肉 250g (目録)'
                }, {
                    'option': 'Sensuke',
                    'src': '../img/Sensuke.jpg',
                    'order': 22,
                    'label': '日本酒 仙介 純米大吟醸 720ml (現物)'
                }, {
                    'option': 'Rice',
                    'src': '../img/Rice.jpg',
                    'order': 23,
                    'label': '長岡産 コシヒカリ 5kg (目録)'
                }, {
                    'option': 'Melon',
                    'src': '../img/Melon.jpg',
                    'order': 24,
                    'label': '静岡県産 クラウンマスクメロン (目録)'
                }, {
                    'option': 'Oyster',
                    'src': '../img/Oyster.jpg',
                    'order': 25,
                    'label': '広島県産 大粒カキフライ 20個 (目録)'
                }, {
                    'option': 'Ice',
                    'src': '../img/Ice.jpg',
                    'order': 26,
                    'label': '銀座千疋屋 ミルフィーユアイス (目録)'
                }, {
                    'option': 'Kaisen',
                    'src': '../img/Kaisen.jpg',
                    'order': 27,
                    'label': '能登半島 北陸海鮮漬け丼の具 6食 (目録)'
                }, {
                    'option': 'Steak',
                    'src': '../img/Steak.jpg',
                    'order': 28,
                    'label': '神戸洋食 デミグラスハンバーグ 9個 (目録)'
                }, {
                    'option': 'Chinese',
                    'src': '../img/Chinese.jpg',
                    'order': 29,
                    'label': '赤坂四川飯店監修 中華料理セット (目録)'
                }, {
                    'option': 'Financier',
                    'src': '../img/Financier.jpg',
                    'order': 30,
                    'label': 'シェフ・アサヤマ フィナンシェ 12個 (目録)'
                }, {
                    'option': 'Ramen',
                    'src': '../img/Ramen.jpg',
                    'order': 31,
                    'label': '喜多方ラーメン 12食 (目録)'
                }, {
                    'option': 'Cake',
                    'src': '../img/Cake.jpg',
                    'order': 32,
                    'label': 'ホシフルーツ 大人のチーズケーキ (目録)'
        }
    ]


function Vote(){
    const [selectedPrize, setselectedPrize] = useState(null);
    const [isVoted, setIsVoted] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [userId, setUserId] = useState('');
    const [votedCategory, setVotedCategory] = useState("");
    const [votedOption, setVotedOption] = useState("");
    const navigate = useNavigate();
    const { category } = useParams();
    const [isProcess, setIsProcess] = useState(false);
    const prizeList = items.find(x => x.category === category).item;
    useEffect(() => {
        setIsVoted(localStorage.getItem('isVoted') == 'true');
        const value = options.filter(x => x.option == localStorage.getItem('option'));
        if(value.length){
            setVotedCategory(localStorage.getItem('category'));
            setVotedOption(value[0].label);
        }

    }, []);

    const handleVote = async (option) => {
        if(isProcess){ return; }
        setIsProcess(true);
        const userId = localStorage.getItem('userId');
        const form = JSON.parse(localStorage.getItem('form'));
        if(votedCategory){
            await axios.post('https://4m8qo3vqvl.execute-api.us-east-1.amazonaws.com/Product', {
                'call': 'Delete',
                'body': JSON.stringify({
                    'userId': userId,
                    'category': votedCategory,
                    'option': localStorage.getItem('option'),
                    'corporate': form.corporate,
                    'team': form.team,
                    'name': form.name
                })
            });
        }
        const requestBody = JSON.stringify({
            'userId': userId,
            'category': category,
            'option': option,
            'corporate': form.corporate,
            'team': form.team,
            'name': form.name
        });

        const result = await axios.post('https://4m8qo3vqvl.execute-api.us-east-1.amazonaws.com/Product', {
            'call': 'PUT /items',
            'body': requestBody
        });
        if(result?.data?.statusCode === 404){
            alert('応募期間は終了しました')
            setIsProcess(false);
            setShowDialog(false);
            return;
        }
        localStorage.setItem('isVoted', true);
        localStorage.setItem('option', option);
        localStorage.setItem('category', category);
        navigate('../results');
    };

    const popup = (e, prize) => {
        e.stopPropagation();
        setselectedPrize(prize);
        setShowDialog(true);
    }

    const cancel = () => {
        setShowDialog(false);
    }

    const reset = () => {
        localStorage.setItem('isVoted', false);
        setIsVoted(false);
    }

    const ok = () => {
        navigate('../results');
    }

    const backToSelectCategory = () => {
        navigate('../category');
    }

    const goToResult = () => {
        navigate('../results');
    }

    return (
        <div className='main' onClick={() => cancel()}>
            <div className='header-div'>
                <img src='../img/header-removebg-preview.png'></img>
            </div>
            <div className='body-div'>
                <div className='base'>
                    <div className='navigate-button-area'>
                        <div className='back-button'><p onClick={() => backToSelectCategory()}>戻る</p></div>
                        <div className='go-to-button'><p onClick={() => goToResult()}>投票状況</p></div>
                    </div>
                    <p style={{paddingLeft: '20px'}}>景品選択</p>
                    <div>
                        {prizeList.map((item) => (
                            // <div className='category-area' style={{'backgroundColor': category.color}} key={category.key} onClick={() => popup(category)}>
                            <div className='list-category' key={item.option} onClick={(e) => popup(e, item)}>
                                <img src={item.src} width={100} height={100}></img>
                                <p>{item.label}</p>
                            </div>
                        ))}
                    </div>
                    {showDialog
                    &&
                    <div className='curtain'></div>
                    }
                    {showDialog
                    &&
                    <div className='dialog' onClick={e => e.stopPropagation()}>
                        {/* <button className='close' onClick={() => cancel()}>
                            <span className='material-symbols-outlined'></span>
                        </button> */}
                        {!votedCategory
                        &&<p className='message'>{selectedPrize.label} に投票しますか？</p>
                        }
                        {votedCategory
                        && <p className='message' style={{"margin": "auto 15px"}}>あなたは {votedCategory} カテゴリの {votedOption} を選択しています<br></br>
                        {selectedPrize.label} に変更しますか？
                        </p>
                        }
                        <div className='list-item'>
                            <div className='item'>
                                <img src={selectedPrize.src}></img>
                                <p className='caption'>{selectedPrize.value}</p>
                            </div>
                        </div>
                        <div className='button-div'>
                        <button onClick={() => cancel()}>考えなおす</button>
                        <button className='submit-button' onClick={() => handleVote(selectedPrize.option)}>投票</button>
                        </div>
                    </div>
                    }
                </div>
            {/* {isVoted
            && 
                <div className='dialog'>
                    <p>すでに投票済みです</p>
                    <div className='button-div'>
                    <button onClick={() => reset()}>リセット</button>
                    <button className='submit-button' onClick={() => ok()}>投票内容を確認する</button>
                        </div>
                </div>
            } */}
        </div>
        </div>
    );
}

export default Vote;